import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ORGANIZATIONS_QUERY_KEY } from 'core/constants';

import { API } from 'core/API';

interface IUseDeleteOrganization {
	// eslint-disable-next-line no-unused-vars
	deleteOrganization: (id: number) => void;
}

const deleteOrganizationApi = async (id: number) => {
	return API.deleteOrganization(id);
};

export const useDeleteOrganization = (): IUseDeleteOrganization => {
	const queryClient = useQueryClient();
	const { mutate: deleteOrganization } = useMutation<void, Error, number>({
		mutationFn: id => deleteOrganizationApi(id),
		onSettled: () => queryClient.invalidateQueries({ queryKey: [ORGANIZATIONS_QUERY_KEY] }),
	});

	return { deleteOrganization };
};
